import React from "react";

import { BrandLockup } from "../BrandLockup";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../../components/Accordion/Accordion";
import { faqs } from "../../../utils/copy";

export function Faq() {
  const [first, ...rest] = faqs;
  return (
    <section id="faq" data-bg="#f0eae1" className="poster-section faq-section">
      <BrandLockup />
      <h2 data-motion="title"><span className="type-display">Perguntas</span><em className="type-voice">frequentes</em></h2>

      <div className="faq-layout faq-layout-wide">
        <Accordion type="single" collapsible defaultValue="faq-0" className="faq-featured">
          <AccordionItem value="faq-0">
            <AccordionTrigger className="type-display">{first.q}</AccordionTrigger>
            <AccordionContent>{first.a}</AccordionContent>
          </AccordionItem>
        </Accordion>
        {/* data-motion-list: as perguntas se empilham em stagger na entrada da
            seção, mesma gramática das outras listas da página */}
        <Accordion type="single" collapsible className="faq-list" data-motion-list>
          {rest.map((faq, index) => (
            <AccordionItem key={faq.q} value={`faq-${index + 1}`}>
              <AccordionTrigger className="type-display">{faq.q}</AccordionTrigger>
              <AccordionContent>{faq.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <div className="faq-layout faq-layout-compact">
        <Accordion type="single" collapsible className="faq-list" data-motion-list>
          {faqs.map((faq, index) => (
            <AccordionItem key={faq.q} value={`compact-faq-${index}`}>
              <AccordionTrigger className="type-display">{faq.q}</AccordionTrigger>
              <AccordionContent>{faq.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
